import { render, staticRenderFns } from "./DiseaseValueEdit.vue?vue&type=template&id=52bae31f&scoped=true"
import script from "./DiseaseValueEdit.vue?vue&type=script&lang=js"
export * from "./DiseaseValueEdit.vue?vue&type=script&lang=js"
import style0 from "./DiseaseValueEdit.vue?vue&type=style&index=0&id=52bae31f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bae31f",
  null
  
)

export default component.exports